import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import '../../../Static/Master/firmtable.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { deleteSingleEmployee } from '../../../Store/PHPSlice/Employee';
import { Preview } from '@mui/icons-material';
import axios from 'axios';


const TableBody2 = ({
    id,
    serialNumber,
    entrydt,
    empId,
    empNm,
    punchId,
    fromdt,
    todt,
    totdays,
    present_days,
    leave_days,
    perHr_pay,
    totwork_hr,
    extra_hr,
    payamt,
    selected,
    handleClick,
}) => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const dispatch = useDispatch();
    const handleEditClick = () => {
        // Replace 'URL' with the actual URL you want to open

        window.open(`/EmployeeEdit/${id}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };
    const handleDeleteClick = () => {
        const isConfirmed = window.confirm("Delete This Attendance Record?");

        // If user confirms, proceed with deletion
        if (isConfirmed) {
            deleteAttendance(id);
        }
    };

    const deleteAttendance = async (id) => {
        try {
            const response = await axios.delete(`${baseUrl}?apicall=deleteEmployeeAttendanceApi&atId=${id}`, {
                method: 'DELETE',
            });
            if (response.status === 'success') {
                alert(response.msg);
                window.location.reload();
            }
            else {
                alert(response.msg);
            }

        } catch (error) {
            console.error("Error deleting pattern:", error);
        }
    };

    const handleEmpDepartClick = () => {
        window.open(`/employee-attendance-view/${id}`, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');
    };

    return (
        <>
            <TableRow hover tabIndex={-1} role="checkbox" selected={selected}>
                {/* <TableCell padding="checkbox">
                    <Checkbox disableRipple checked={selected} onChange={handleClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{serialNumber}</TableCell>


                <TableCell component="th" scope="row" sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {entrydt}

                </TableCell>



                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{empNm}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{punchId}</TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {fromdt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {todt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {totdays}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', width: '15vw' }} align='center'>
                    {present_days}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {leave_days}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {perHr_pay}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {totwork_hr}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    {extra_hr}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000', width: '15vw' }} align='center'>
                    {payamt}
                </TableCell>

                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <Preview className='cursor-pointer' onClick={handleEmpDepartClick} />
                </TableCell>

                {/* <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <EditIcon className="cursor-pointer" onClick={handleEditClick} />
                </TableCell> */}
                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                    <DeleteIcon className="cursor-pointer" onClick={handleDeleteClick} />
                </TableCell>


            </TableRow>
            <ToastContainer />
        </>
    );
};

export default TableBody2;
